import { TFunction } from "i18next";
import { IUserActivityMeta } from "../interface";

const BILLING_ACTION_TYPES = new Set([
  "TRIAL_STARTED",
  "TRIAL_ENDED",
  "SUBSCRIPTION_CREATED",
  "SUBSCRIPTION_RENEWED",
  "SUBSCRIPTION_CANCELLED",
  "SUBSCRIPTION_REACTIVATED",
  "PAYMENT_SUCCEEDED",
  "PAYMENT_FAILED",
  "REFUND_REQUESTED",
  "REFUND_PROCESSED",
]);

export const isBillingActivity = (actionType: string) =>
  BILLING_ACTION_TYPES.has(actionType);

interface BillingMetaProps {
  meta: IUserActivityMeta;
  t: TFunction;
}

const BillingMeta = ({ meta, t }: BillingMetaProps) => {
  const rows: { label: string; value: string }[] = [];

  if (meta.plan) {
    rows.push({ label: t("userActivity.meta.plan"), value: meta.plan });
  }

  if (meta.amount && meta.currency) {
    rows.push({
      label: t("userActivity.meta.amount"),
      value: `${meta.currency} ${parseFloat(meta.amount).toFixed(2)}`,
    });
  }

  // if (meta.status) {
  //   rows.push({ label: t("userActivity.meta.status"), value: meta.status });
  // }

  if (meta.reason) {
    rows.push({
      label: t("userActivity.meta.reason"),
      value: t(`billing.reasons.${meta.reason}`, meta.reason),
    });
  }

  if (meta.immediate !== undefined) {
    rows.push({
      label: t("userActivity.meta.cancelMode"),
      value: meta.immediate
        ? t("userActivity.meta.immediate")
        : t("userActivity.meta.endOfPeriod"),
    });
  }

  if (rows.length === 0) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {rows.map(({ label, value }) => (
        <span
          key={label}
          className="inline-flex items-center gap-1 text-xs bg-gray-50 dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded px-2 py-1"
        >
          <span className="text-gray-500 dark:text-gray-400">{label}:</span>
          <span className="font-medium text-gray-800 dark:text-gray-200">{value}</span>
        </span>
      ))}
    </div>
  );
};

export default BillingMeta;
